module.exports = __webpack_public_path__ + "media/images/personalization_tool-d13ee6b1d69f1ede4d31ebacaf10255d.png";